import * as React from 'react';

const EmailSentPopup = (props) => {
    const { SetStatus, data } = props;

    const getTitleText = () => {
        if (data.result.includes("success")) {
            return 'Email Sent';
        }
        return 'Email Failed';

    }
    const getBodyText = () => {
        if (data.result.includes("success")) {
            return 'Email sent Successfully'
        }

        return 'Your Email has not been sent, please try again.'
    }

    const getFooterButtonText = () => {

        return 'Close';
    }
    return (
        <>
            <div className="avnet-modal modal-350">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    {!data?.isRegister && (

                        <button type="button" className="close" data-dismiss="modal"
                            onClick={() => {
                                SetStatus(false)
                            }}>×
                        </button>
                    )}
                    <div className="modal-header justify-content-center">
                        <h1 className="pcn-modal-heading ps-4 pe-4">
                            {data?.isRegister ?
                                <span className=''>{getTitleText()} </span>
                                : getTitleText()}
                        </h1>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="text-center mb-3">
                            {getBodyText()}
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-primary minw140"
                                onClick={() => {

                                    SetStatus(false)

                                }}
                            >
                                {getFooterButtonText()}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmailSentPopup;